import Modal from "./Modal";

export default Modal;



// WEBPACK FOOTER //
// ./src/commonComponents/Modal/index.js